export class ActionInformation {
  public message: string;
  public requiredConfirm: boolean;
}
